import dayjs, { Dayjs } from "dayjs";

type UseSessionStorageDatesReturn = {
    storedStartDate: Dayjs;
    storedEndDate: Dayjs;
    storeSessionStorageDates: (param1: Dayjs, param2: Dayjs) => void
};

type DatesObj = {
    startDate: Dayjs;
    endDate: Dayjs;
}

const useSessionStorageDates = (storageKey: string, defaultStartDate?: Dayjs, defaultEndDate?: Dayjs): UseSessionStorageDatesReturn => {
    const storedDates = JSON.parse(sessionStorage.getItem("dmsSessionStorageDates") ?? "{}") || {};

    let storedStartDate: Dayjs;
    let storedEndDate: Dayjs;   

    const datesObj: DatesObj = storedDates?.[storageKey] || {}

    if (datesObj && Object.keys(datesObj)?.length == 2) {
        storedStartDate = dayjs(datesObj?.startDate)
        storedEndDate = dayjs(datesObj?.endDate)
    } else {
        storedStartDate = defaultStartDate ? defaultStartDate : dayjs();
        storedEndDate = defaultEndDate ? defaultEndDate : dayjs();
        storeSessionStorageDates(storedStartDate, storedEndDate)
    }

    function storeSessionStorageDates(startDate: Dayjs, endDate: Dayjs) {
        const dateObj = {
            startDate: startDate.toISOString(),
            endDate: endDate.toISOString(),
        };
    
        sessionStorage.setItem("dmsSessionStorageDates", JSON.stringify({ [storageKey]: dateObj }));
    }
    


    return {
        storedStartDate,
        storedEndDate,
        storeSessionStorageDates
    };
};

export default useSessionStorageDates;
